import { Output } from "valibot";

import {
  BaseIntegrationsSchema,
  LocationBasedConsentInfo,
} from "components/SonicBot/schemas";
import { getLocalStorageValue } from "shared/functions";
import { requestBackend } from "shared/request";
import { AppConfiguration } from "shared/types";

import HelpScoutIntegrationHandler, { HelpScoutIntegration } from "./helpscout";

import { BaseIntegrationHandler } from ".";

type IntegrationConfig = {
  widget_fields: Array<string>;
};

type ValuesObject = {
  [key: string]: any;
};

export const generateIntegrationHandlers = (
  integrations: Output<typeof BaseIntegrationsSchema>,
) => {
  const integrationHandlers: BaseIntegrationHandler[] = [];
  for (const integration of integrations) {
    switch (integration.name) {
      case "Helpscout":
        // Create integration handlers by sorting through name
        integrationHandlers.push(
          new HelpScoutIntegrationHandler(integration as HelpScoutIntegration),
        );
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Unknown Integration: " + integration);
        break;
    }
  }
  return integrationHandlers;
};

export function createIntegrationData(
  keys: string[],
  values: ValuesObject,
): ValuesObject {
  return keys.reduce((data: ValuesObject, key: string) => {
    if (values.hasOwnProperty(key)) {
      data[key] = values[key];
    }
    return data;
  }, {});
}

export async function getIntegrationConfigs({
  id,
  config,
  bot_id,
}: {
  id: string;
  config: AppConfiguration;
  bot_id: string;
}): Promise<IntegrationConfig> {
  try {
    const response = await requestBackend(
      `/v1/integrations/${bot_id}/integration/widget/${id}`,
      {
        headers: {
          token: config.token,
        },
      },
    );
    return await (response as Promise<IntegrationConfig>);
  } catch (err) {
    throw err;
  }
}

export const isShowLocationBasedConsentForm = (
  botId: string,
  locationBasedConsentInfo?: Output<typeof LocationBasedConsentInfo>,
) => {
  if (!locationBasedConsentInfo) {
    return false;
  }
  const localStoarageConsentInfo = JSON.parse(
    getLocalStorageValue(`consentInfo__${botId}`) || "null",
  );
  const showLocationBasedConsentForm =
    locationBasedConsentInfo?.is_required &&
    (!localStoarageConsentInfo ||
      !localStoarageConsentInfo?.isConsentGiven ||
      localStoarageConsentInfo?.lastUpdatedAt !==
        locationBasedConsentInfo?.updated_at);

  return showLocationBasedConsentForm;
};
